export default "__VITE_ASSET__031ee3fa__"